import Styles from './styles.module.scss';

import { CloseIcon } from '@/components/Elements/Icons';

interface Props {
	value: string[];
	onChange: (value: string[]) => void;
	renderUserName: (userId: string) => string;
}

export const ToUsers = ({ value, onChange, renderUserName }: Props) => {
	return (
		<div className={Styles.recipientList}>
			{value.map((userId) => (
				<div key={userId} className={Styles.recipient}>
					<span>
						{renderUserName(userId)}
						{/* {usersById?.[userId]?.firstName ?? ''} {usersById?.[userId]?.lastName ?? ''} */}
					</span>
					<button
						type="button"
						className={Styles.removeButton}
						onClick={() => onChange(value.filter((id) => id !== userId))}
					>
						<CloseIcon />
					</button>
				</div>
			))}
		</div>
	);
};
